import type SubformId from "../state/SubformId";

import type { SubformEditorTab } from "../pages/formEditor/subforms/types";

class SubformShowEvent extends Event {
  static name = "subform.show";

  public readonly subformId: SubformId;
  public readonly tab: SubformEditorTab;

  constructor(subformId: SubformId, tab: SubformEditorTab = "fields") {
    super(SubformShowEvent.name, { bubbles: false });
    this.subformId = subformId;
    this.tab = tab;
  }

  send() {
    setTimeout(() => document.dispatchEvent(this));
  }
}

export default SubformShowEvent;
